/*
 * @Author: wzc
 * @Date: 2021-10-25 10:42:36
 * @LastEditors: wzc
 * 超赛平台 base mixins 足球 | 综合性赛事【大运会|亚运会】 | 马拉松 | 篮球 容器共用部分
 * @LastEditTime: 2021-10-25 19:11:02
 */

import customizeProMixins_data_mixin from '@customizeProMixins/index.js'

export default {
  mixins: [customizeProMixins_data_mixin],
  data() {
    return {
      //   currCid: null,
      //   currSid: null,
      //   currSeasonName: null,
      //   dynamicConfig: null,
      //   sportsTypeArr: ['combat', 'uncombat'],
      //   defaultPath: ['compreSportsMeet', 'universiades', 'schedule'],
      //   axiosBaseUrl: 'fisuwug',
    }
  },
  beforeCreate() {
    this.dynamicConfig = this.$dynamicConfig
  },
  created() {
    let queryParams = this.$route.query
    const fullPath = this.$route.fullPath
    const pathModule = this.$route.meta.pathModule
    console.debug('this.$route:', this.$route, fullPath)
    let currCidKey = null
    if (fullPath && fullPath.indexOf('/') > -1) {
      currCidKey = fullPath.split('/')[1]

      let currSeasonMap = JSON.parse(
        this.$localStorage.getItem('mixtmt_platfromV4_currSeasonMap')
      )
      let currSeason = {}
      if (!currSeasonMap) {
        currSeasonMap = {}
      } else {
        currSeason = currSeasonMap[currCidKey]
        if (queryParams.sid && currSeason.sid !== queryParams.sid) {
          // 当页面路径参数有sid时取页面路径sid，而不是缓存中，这个有可能是之前开的另外一个赛季的某个详情页（赛果），之后他切换了其他赛季，然后又回到这个详情页（赛果）刷新，此时当前赛季和这个页面的赛季是不一致的，需要按照这个详情页的赛季显示数据；其他没有sid的按照当前缓存中最新的渲染
          currSeason.sid = queryParams.sid
        }
      }

      if (currSeason && currSeason.cid) {
        this.currCid = currSeason.cid
      }
      let currThemePathUrl = pathModule ? pathModule : this.defaultPath
      // this.$dynamicConfig.includeTheme.football.FIFAWC_107
      const themeArr =
        this.$dynamicConfig.includeTheme[currThemePathUrl[0]][
          `${currThemePathUrl[1]}_${
            queryParams.cid ? queryParams.cid : this.currCid
          }`
        ]
      console.debug(
        'currSeason:',
        this.currCid,
        currSeasonMap,
        queryParams,
        currSeasonMap.sid === queryParams.sid,
        fullPath,
        currSeason,
        currThemePathUrl,
        currSeasonMap,
        currCidKey,
        themeArr
      )
      if (!currSeason || !currSeason.sid) {
        let sidIndex = 0
        currSeason = {}
        currSeason.cid = this.currCid
        currSeason.sid = themeArr[sidIndex].sid
        currSeason.name = themeArr[sidIndex].name
        currSeason.sportType = themeArr[sidIndex].sportType
        currSeasonMap[currCidKey] = currSeason
        this.$localStorage.setItem(
          'mixtmt_platfromV4_currSeasonMap',
          JSON.stringify(currSeasonMap)
        )
      }

      this.currSid = currSeason.sid
      this.currSeasonName = currSeason.name

      window.mixtmt_platfrom.pathModule = currThemePathUrl
    } else {
      console.debug('url路径匹配不对')
    }

    this.openEventBus_publicThemeDialogEvent()
  },
  mounted() {},
  computed: {
    currThemeObj() {
      console.debug('currThemeObj发生变化')
      let themeArr = null
      let currThemeObj = null
      let queryParams = this.$route.query
      let currThemePathUrl = this.$route.meta.pathModule
        ? this.$route.meta.pathModule
        : this.defaultPath
      console.debug(
        'currThemePathUrl:',
        currThemePathUrl,
        queryParams,
        this.currCid,
        this.currSid,
        themeArr
      )
      // this.$dynamicConfig.includeTheme.football.FIFAWC_107
      themeArr =
        this.$dynamicConfig.includeTheme[currThemePathUrl[0]][
          `${currThemePathUrl[1]}_${
            queryParams && queryParams.cid ? queryParams.cid : this.currCid
          }`
        ]

      if (themeArr && themeArr.length > 0) {
        if (this.onlyOneSeasonFlag) {
          // 只有一个赛季的赛事，比如cba
          currThemeObj = themeArr[0]
        } else {
          if (this.themeSeasonArr && this.themeSeasonArr.length > 0) {
            for (let i = 0; i < this.themeSeasonArr.length; i++) {
              const themeSeason = this.themeSeasonArr[i]
              if (
                themeSeason.sidArr &&
                themeSeason.sidArr.includes(this.currSid.toString())
              ) {
                currThemeObj = themeArr[themeSeason.themeIndex]
                break
              }
            }
          } else {
            // for (let i = 0; i < themeArr.length; i++) {
            //   const theme = themeArr[i]
            //   if (this.currSid == theme.sid) {
            //     // 暂时没有主题皮肤变化，所以代码暂时保留，以后启用
            //     // currThemeObj = theme
            //     // 由于没有皮肤可变，暂时默认写死都是第一个皮肤
            //     currThemeObj = themeArr[0]
            //     break
            //   }
            // }
          }
          if (currThemeObj) {
            this.platfromMenu_selectData.forEach((select) => {
              // console.debug(select, this.currSid)
              if (select.key == this.currSid) {
                select.act = true
              } else {
                select.act = false
              }
            })
          }
        }
      }
      console.debug(
        'themeArr:',
        this.themeSeasonArr,
        themeArr,
        this.currSid,
        currThemeObj,
        this.themeSeasonArr
      )
      if (!currThemeObj || !themeArr) {
        console.error('暂不支持同时查看多个赛事项目')
      } else {
        // 数据包装的日期下拉框和时间下拉框需要这些颜色

        const colorKeys = Object.keys(currThemeObj.cssStyle)
        const styleArr = []
        colorKeys.forEach((key) => {
          if (key) {
            styleArr.push(`--mixtmt_${key}:${currThemeObj.cssStyle[key]}`)
          }
        })
        if (currThemeObj.comImgStyle) {
          // 设置普通的图片
          currThemeObj.comImgStyle.forEach((imgName) => {
            if (imgName.indexOf('.') > -1) {
              styleArr.push(
                `--mixtmt_${imgName.split('.')[0]}: url(/static/${
                  currThemeObj.sportType
                }/${currThemeObj.imageUrl}/${imgName})`
              )
            }
          })
        }
        const styleId = `mixtmt_rootStyle`
        let styleDom = document.getElementById(styleId)
        if (!styleDom) {
          styleDom = document.createElement('style')
          styleDom.id = styleId

          styleDom.textContent = `:root {${styleArr.join(';')}}`
          document.head.appendChild(styleDom)
        } else {
          styleDom.textContent = `:root {${styleArr.join(';')}}`
        }
      }

      console.debug('currThemeObj:', currThemeObj)
      return currThemeObj
    },
  },
  methods: {
    actStyleItemEventHandler(childData) {
      let publicThemeDialogObj = JSON.parse(
        JSON.stringify(this.publicThemeDialogObj)
      )
      console.debug('publicThemeDialogObj:', publicThemeDialogObj)
      publicThemeDialogObj.analysisItemStyles.forEach((styleItem) => {
        // 多选逻辑
        if (styleItem.styleId === childData.styleId) {
          styleItem.act = !childData.act
        }

        // 单选
        // if (styleItem.styleId === childData.styleId) {
        //   styleItem.act = true
        // } else {
        //   styleItem.act = false
        // }
      })

      this.setPublicThemeDialogObj(publicThemeDialogObj)
      this.$forceUpdate()
      console.debug(
        'actStyleItemEventHandler:',
        childData,
        publicThemeDialogObj
      )
    },
    setPublicThemeDialogObj(publicThemeDialogObj) {
      this.publicThemeDialogObj = JSON.parse(
        JSON.stringify(publicThemeDialogObj)
      )
    },
    openEventBus_publicThemeDialogEvent() {
      // 开启分享主题监听事件
      window.mixtmtBase_eventBus.$on('publicThemeDialogEvent', (data) => {
        console.debug('publicThemeDialogEvent:', data)
        const flag = data && data.flag ? true : false
        this.isShowPublicThemeDialog = flag //为true唤起弹窗
        window.mixtmt_platfrom.isShowPublicThemeDialog = flag
        window.mixtmt_platfrom.needPublicThemeData = data.themeItem
        let publicThemeDialogObj = {
          analysisItemId: data.themeItem.analysisItemId,
          dialogType: '',
          dialogText: `请确认主题【${data.themeItem.analysisItemName}】的分享配置`,
          mid: data.mid,
          useSceneArr:
            data.themeItem.useScene.indexOf(',') > -1
              ? data.themeItem.useScene.split(',')
              : [data.themeItem.useScene],
          analysisItemStyles: data.themeItem.analysisItemStyles
            ? data.themeItem.analysisItemStyles
            : null,
          graphicsId: data.themeItem.graphicsId, //多选主题【今日赛程|频道预告】等需要
          multipleChoiceShareFixedBtn_modeType:
            data.multipleChoiceShareFixedBtn_modeType //多选主题【今日赛程|频道预告】等需要
              ? data.multipleChoiceShareFixedBtn_modeType
              : null,
        }
        this.setPublicThemeDialogObj(publicThemeDialogObj)
      })
    },
    async createdThemeBeforeFormatThemeItem(data) {
      // 点击确定分享之后，发送创建分享主题接口之前，对主题数据的格式化处理

      // 无论有没有数据都要将值赋值为false
      this.isShowPublicThemeDialog = false
      window.mixtmt_platfrom.isShowPublicThemeDialog = false
      if (data && data.flag && window.mixtmt_platfrom.needPublicThemeData) {
        let needPublicThemeData = JSON.parse(
          JSON.stringify(window.mixtmt_platfrom.needPublicThemeData)
        )
        let newData = JSON.parse(JSON.stringify(data))

        if (needPublicThemeData.graphicsId === 2007) {
          // cba 晋级图 赛季单独处理
          newData.data.sid = needPublicThemeData.seasonId
        }

        console.debug('needPublicThemeData:', needPublicThemeData, newData)
        if (needPublicThemeData.analysisItemId == newData.data.analysisItemId) {
          // containerFull_common_data.js
          needPublicThemeData = this.createThemeItemBreforToFormat(
            needPublicThemeData,
            newData
          )
          await this.createDataItem(needPublicThemeData, newData.data)
        } else {
          console.debug('分享的analysisItemId值不相等')
        }
      }
      window.mixtmt_platfrom.needPublicThemeData = null
      this.publicThemeDialogObj = null
    },
    async publicThemeDialogHandler(data) {
      // 调用该方法就2个地方，1、主容器这里；2、多选浮层分享按钮（创建后的回调函数不能通过这里实现，所以单独抽出）；查询这个 publicThemeDialogHandler 方法就能看到
      console.debug('full publicThemeDialogHandler:', data)
      // 在容器中分享主题组件中使用
      this.createdThemeBeforeFormatThemeItem(data)
    },
    getLocalStorageChooseObj(localStorageName) {
      return JSON.parse(this.$localStorage.getItem(localStorageName))
    },
  },
}
